export default __webpack_public_path__ + "static/in-w2-amazon-main-diagram-en2-690e37fab3e4b4d6a012ad077db03009.webp";